import { useLoaderData } from "react-router-dom";

import { OrderAheadOrder } from "../orderAheadOrder";
import { ShowLayout } from "../../../../layout/ShowLayout";
import { usdFormat } from "../../../../utils";
import { ShowRow } from "../../../../components/ShowRow";

export const TotalList = () => {
  const order = useLoaderData() as OrderAheadOrder;
  const refunded = order.transactions?.reduce((acc, transaction) => {
    const amountRefund =
      transaction?.payment?.status === "refund"
        ? transaction.payment.amount
        : 0;
    return acc + amountRefund;
  }, 0);

  const total =
    (order.subtotal + order.digital_surcharge + order.tip + order.tax) / 100 -
      (refunded ?? 0) / 100;

  return (
    <ShowLayout header="Total">
      <ShowRow
        label="Subtotal"
        value={usdFormat.format(order.subtotal / 100)}
      />
      <ShowRow
        label="Service Fee"
        value={usdFormat.format(order.digital_surcharge / 100)}
      />
      <ShowRow label="Tip" value={usdFormat.format(order.tip / 100)} />
      <ShowRow label="Tax" value={usdFormat.format(order.tax / 100)} />
      <ShowRow
        label="Amount Refunded"
        value={usdFormat.format((refunded ?? 0) / 100)}
      />
        <ShowRow label="Total" value={usdFormat.format(total)} />
    </ShowLayout>
  );
};
